<template>
  <el-input v-model="nickname" @blur='onBlur'></el-input>
</template>

<script setup>
import { editStudentReceiveWeChatInfo } from '@/api/common.js'
import { ElNotification,ElMessage } from 'element-plus';
import { computed } from 'vue';
const emit = defineEmits(['update:modelValue','blur'])
const props = defineProps({
  studentCode:{
    required:true
  },
  needSave:{
    type: Boolean,
    default: true
  },
  modelValue:{
    default:''
  },
  placeholder:{
    default: '请输入该学员沟通称呼语'
  }
})
let savedNickname = props.modelValue;
const nickname = computed({
  get:()=>props.modelValue,
  set:(v)=>{
    emit('update:modelValue',v)
  }
})
const onBlur = ()=>{
  emit('blur')
  if(nickname.value?.trim()){
    editNickName();
  }else{
    ElMessage.warning('沟通称呼语不能为空，自动回填之前的称呼')
    nickname.value = savedNickname
  }
  
}
const editNickName = () => {
  editStudentReceiveWeChatInfo({
    nickName: nickname.value,
    studentCode: props.studentCode
  }).then(res=>{
    savedNickname = nickname.value;
  }).catch(err=>{
    if(!props.needSave)return;
    ElNotification({
      title: '提示',
      message: `沟通称呼语更新失败（${err}）`,
      type: 'error',
    })
  })
}
</script>

<style lang="scss" scoped></style>